import { LinkExternal, X } from '@ui/components/icons';
import { Portal } from '@ui/lib/park/portal';
import { Button } from '@ui/lib/park/ui/button';
import { Dialog } from '@ui/lib/park/ui/dialog';
import { Icon } from '@ui/lib/park/ui/icon';
import { Link } from '@ui/lib/park/ui/link';
import { Text } from '@ui/lib/park/ui/text';
import { Flex } from 'styled-system/jsx';

export const CommonPopupModal = ({
  title,
  subTitle,
  content,
  actions,
  ...p
}: Dialog.RootProps & {
  title: string;
  subTitle: string;
  content: React.ReactNode;
  actions?: {
    link: string;
    label: string;
    onClick?: () => void;
  }[];
}) => {
  return (
    <Dialog.Root
      lazyMount
      unmountOnExit
      modal={false}
      type="desktopModal_mobileDrawer"
      {...p}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="black.lv1" color="greyWhite.lightGrey1">
            <Dialog.Title asChild>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                p="16px"
                borderBottom="1px solid"
                borderColor="greyWhite.outline"
                bg="black.lv2"
              >
                <Text textStyle="headings.large">{title}</Text>
                <Dialog.CloseTrigger asChild>
                  <Button aria-label="Close" variant="modalCloseButton">
                    <Icon boxSize="6">
                      <X />
                    </Icon>
                  </Button>
                </Dialog.CloseTrigger>
              </Flex>
            </Dialog.Title>

            <Dialog.Description
              p="4"
              display="flex"
              flexDir="column"
              alignItems="stretch"
              textStyle="textParagraph.small"
            >
              <Text textStyle="headings.xlarge" mb={3}>
                {subTitle}
              </Text>

              {content}

              {actions && (
                <Flex gap={4} mt={12} flexDir="column">
                  {actions.map((action) => (
                    <Button
                      key={action.link}
                      variant="primary"
                      w="full"
                      size="big"
                      onClick={action.onClick}
                      asChild
                    >
                      <Link href={action.link} target="_blank" variant="text">
                        {action.label}
                        <Icon boxSize="6" ml={1}>
                          <LinkExternal />
                        </Icon>
                      </Link>
                    </Button>
                  ))}
                </Flex>
              )}
            </Dialog.Description>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
